import React from 'react';
import Icons from './Images'
import RecordCom from '../Components/RecordCom'
import { CustomerText } from '../CustomerText'
import Config from '../Config'
import Pagination from './Components/Pagination'
import LiveChat from './Components/LiveChat'
const { Language, platform, locale, RecordFilter, format } = Config()
const lengthObj = {//https://arcadie.atlassian.net/browse/CUSP-31
    Mobile: 60,
    Web: 95
}

export default class Question extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    renderRecordCs({ v, tempText, OpenLiveChat, piwikStatus = '' }) {
        return <div className="csBtn" onClick={() => {
            OpenLiveChat({
                type: 'closeOut',
                listingParams: `&CUSTOM!CaseNumber=${encodeURI(v?.caseNumber)}&CUSTOM!CaseCategory=${encodeURI(v?.questionType)}`,
                piwikStatus
            })
        }}>
            <div className="csBtnText">{tempText?.text11}</div>
        </div>
    }

    renderRecordTip({ v, tempText, isOpenDes }) {
        return !!v?.noteToMember &&
            <div className="tipBox">
                <div className="tipBoxText1">{tempText?.text14}</div>
                <div className={`tipBoxText2 ${isOpenDes ? '' : 'hiddenText'}`}>{v?.noteToMember}</div>
            </div>
    }

    renderRecordArrow({ v, i, currentRecordIndex, changeRecordIndex, isOpenDes, isShowArrow }) {
        return isShowArrow && <img
            src={Icons.rightArrow}
            className='rightArrow'
            style={{
                transform: `rotate(${isOpenDes ? '-90deg' : '90deg'})`,
            }}
            onClick={() => {
                changeRecordIndex(i == currentRecordIndex ? -999 : i)
            }}
        ></img>
    }

    renderRecordStatus({ v, tempText }) {
        return <div className="recordTextStatus" style={{ color: v?.color }}>{v?.text}</div>
    }

    renderRecordTime({ v, tempText }) {
        return <div>
            <div className="recordTextTime">{tempText?.text13} {v?.dateCreated}</div>
            {
                v?.status == 4 &&
                <div className="recordTextTime">{tempText?.text16} {v?.dateClosed}</div>
            }
        </div>
    }

    renderSignedImg({ v, tempText, Info, isOpenDes }) {
        return (Array.isArray(v?.signedURLArr) && !!v?.signedURLArr.length) && isOpenDes &&
            <div className="recordSignedImgbox">
                {
                    v?.signedURLArr.map((v, i) => {
                        let widths = v?.layout?.width || 200
                        let heights = v?.layout?.height || 200
                        let flag = widths >= heights
                        let rate = (flag ? widths / heights : heights / widths).toFixed(2)
                        return <div
                            onClick={() => {
                                Info({
                                    title: tempText?.text36,
                                    isShowCloseBtn: true,
                                    children: <div className=''>
                                        <img
                                            //source={{ uri: 'data:image/png;base64,' + v?.fileBytes }}
                                            src={v?.uri}
                                            className="modaluploadImg"
                                            style={{
                                                width: '250' + 'px',
                                                height: (flag ? ((250) / rate) : ((250) * rate)) + 'px'
                                            }}
                                        ></img>
                                        <div className="modaluploadImgName">{v?.name}</div>
                                    </div>
                                })
                            }}
                            key={i}>
                            <img
                                src={v?.uri}
                                className="recordImg"
                            ></img>
                        </div>
                    })
                }
            </div>
    }


    render() {
        let { questionTypes, ProgressStatus, isUserLogin, RouterLogin, OpenLiveChat, RouterFeedback, Info } = this.props
        let tempText = CustomerText[Language]
        return <div className="recordContainer">
            <RecordCom
                ProgressStatus={ProgressStatus}
                questionTypes={questionTypes}
                Content={({ recordData, changeDate, dateFrom, dateTo, questionTypesIndex, ProgressStatusIndex, onFilter, totalPaginationNum, changePaginationIndex, currentPaginationIndex, MaxRange, MaxInterval, currentRecordIndex, changeRecordIndex }) => {
                    let lengthNum = lengthObj[platform]
                    return <div>
                        <RecordFilter
                            format={format}
                            MaxRange={MaxRange}
                            MaxInterval={MaxInterval}
                            ProgressStatus={ProgressStatus}
                            ProgressStatusIndex={ProgressStatusIndex}
                            questionTypes={questionTypes}
                            questionTypesIndex={questionTypesIndex}
                            onFilter={onFilter}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            changeDate={changeDate}
                            tempText={tempText}
                            Language={Language}
                            locale={locale}
                        ></RecordFilter>

                        {
                            isUserLogin
                                ?
                                (
                                    Array.isArray(recordData) && !!recordData.length
                                        ?
                                        <div>
                                            <div>
                                                {
                                                    recordData.map((v, i, self) => {
                                                        // v.dateClosed = '2033/33//333'
                                                        let isOpenDes = i == currentRecordIndex
                                                        let isShowArrow = v?.description?.length > lengthNum || v?.noteToMember?.length > lengthNum || (Array.isArray(v?.signedURLArr) && v?.signedURLArr.length > 0)
                                                        return <div key={i} className='recordListBox'>
                                                            {
                                                                platform == 'Mobile'
                                                                    ?
                                                                    <div className="recordListBoxMobile" style={{ marginBottom: i == self.length - 1 ? '80px' : '10px' }}>
                                                                        <div className="recordList">
                                                                            <div className="recordList1">
                                                                                <div className="recordTextCom">{tempText?.text9}</div>
                                                                                <div className="recordText2">{v?.questionType}</div>
                                                                            </div>


                                                                            {this.renderRecordStatus({ v, tempText })}
                                                                        </div>

                                                                        <div className="recordList">
                                                                            <div className="recordList1">
                                                                                <div className={`recordTextCom recordTextCom${Language}`}>{tempText?.text10}</div>
                                                                                <div className="recordText2">{v?.caseNumber}</div>
                                                                            </div>
                                                                            {this.renderRecordCs({ v, tempText, OpenLiveChat, piwikStatus: v?.text })}
                                                                        </div>

                                                                        <div className="recordBottom">
                                                                            <div className="eventNameBox">
                                                                                <div className="recordTextCom">{tempText?.text12}</div>
                                                                                {this.renderRecordArrow({ v, i, currentRecordIndex, changeRecordIndex, isOpenDes, isShowArrow })}
                                                                            </div>
                                                                            <div className={`tipBoxText2 ${isOpenDes ? '' : 'hiddenText'}`} style={{ padding: '8px 0' }}>{v?.description}</div>

                                                                            {this.renderSignedImg({ v, tempText, Info, isOpenDes })}

                                                                            {this.renderRecordTip({ v, tempText, isOpenDes })}

                                                                            {this.renderRecordTime({ v, tempText })}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div className="recordListBoxWeb">
                                                                        <div className="recordList">
                                                                            <div className="recordTextCom">{v?.questionType}</div>
                                                                            {this.renderRecordStatus({ v, tempText })}
                                                                        </div>

                                                                        <div className="recordList1">
                                                                            <div className="recordList2">
                                                                                <div className="recordList3">
                                                                                    <div className={`recordTextCom recordTextCom${Language}`}>{tempText?.text10}</div>
                                                                                    <div className="recordTextCom">{v?.caseNumber}</div>
                                                                                </div>

                                                                                {this.renderRecordTime({ v, tempText })}
                                                                            </div>

                                                                            <div className="recordList4">
                                                                                <div className="recordText3">{tempText?.text12}</div>
                                                                                <div className={`recordTextCom ${isOpenDes ? '' : 'hiddenText'}`}>{v?.description}</div>

                                                                                {this.renderSignedImg({ v, tempText, Info, isOpenDes })}


                                                                                {this.renderRecordTip({ v, tempText, isOpenDes })}

                                                                                {this.renderRecordArrow({ v, i, currentRecordIndex, changeRecordIndex, isOpenDes, isShowArrow })}


                                                                            </div>

                                                                            {this.renderRecordCs({ v, tempText, OpenLiveChat })}
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    })
                                                }
                                            </div>

                                            {
                                                platform == 'Web' && <Pagination
                                                    changePaginationIndex={changePaginationIndex}
                                                    totalPaginationNum={totalPaginationNum}
                                                    currentPaginationIndex={currentPaginationIndex}
                                                ></Pagination>
                                            }
                                        </div>
                                        :
                                        <div className="noDataBox">
                                            <img
                                                src={Icons.noData}
                                                className="noDataImg"
                                            ></img>
                                            <div className="noDataText">{tempText?.text48}</div>
                                            {/* <div className='mobileFeedBox'>
                                                <div className="noDataText1">{tempText?.text47}</div>
                                                <div className="noDataBtn" onClick={() => {
                                                    RouterFeedback({
                                                        fromPage: 'Record'
                                                    })
                                                }}>
                                                    <div className="noDataBtnText">{tempText?.text8}</div>
                                                </div>
                                            </div> */}
                                        </div>
                                )
                                :
                                <div className="noDataBox">
                                    <div className="noDataText1">{tempText?.text45}</div>
                                    <div className="noDataBtn" onClick={RouterLogin}>
                                        <div className="noDataBtnText">{tempText?.text46}</div>
                                    </div>
                                </div>
                        }

                        <LiveChat OpenLiveChat={OpenLiveChat} className={(Array.isArray(recordData) && recordData.length > 0) ? 'hide' : 'record'}></LiveChat>
                    </div>
                }}
            >
            </RecordCom>
        </div>
    }
}